// src/vo/quyen.js

// ============================================================
// 🔑 ĐỌC QUYỀN CỦA MỘT NGƯỜI
// ------------------------------------------------------------
// Trước Đợt N1, sáu file chép lại y nguyên khối này:
//
//     const laAdmin = user?.role === "admin";
//     const quyen = user?.permissions?.family || {};
//     const coTheThem = laAdmin || quyen.add === true;
//     const coTheSua  = laAdmin || quyen.edit === true;
//     const coTheXoa  = laAdmin || quyen.delete === true;
//
// ⚠️ VÌ SAO CHUYỆN NÀY QUAN TRỌNG HƠN VẺ NGOÀI CỦA NÓ:
// Đã từng có lúc mã xét `user.role === "editor"` — một vai trò KHÔNG TỒN TẠI
// trong database (chỉ có "admin" và "member"). Hậu quả: admin tick đủ mọi ô
// quyền mà thành viên vẫn thấy giao diện chỉ-đọc; cả bảng phân quyền chỉ là
// trang trí. Lỗi đó nằm rải ở nhiều file nên phải đi sửa từng chỗ.
//
// Chép luật ra sáu chỗ nghĩa là sáu chỗ có thể lệch nhau. Từ nay MỘT chỗ.
//
// Đây là HÀM THƯỜNG, không phải hook — nó không dùng useState/useEffect gì
// cả. Cố ý không đặt tên `useQuyen`: tên bắt đầu bằng "use" làm người đọc
// tưởng phải theo luật gọi hook.
// ============================================================

/**
 * @param {object} user  người đang đăng nhập
 * @returns quyền trên các mục CHUNG, cộng hàm `rieng()` cho mục có luật riêng
 */
export function docQuyen(user) {
  const laAdmin = user?.role === "admin";
  const q = user?.permissions?.family || {};

  return {
    laAdmin,
    xem: laAdmin || q.view === true,
    them: laAdmin || q.add === true,
    sua: laAdmin || q.edit === true,
    xoa: laAdmin || q.delete === true,

    // Ô quyền RIÊNG của một mục — hiện có `chi_tieu.soan`, sắp có `lich.soan`.
    // Xem chú thích trong AdminPanel.js về việc CỐ Ý không làm ma trận đầy đủ:
    // mọc từng ô theo nhu cầu có thật rẻ hơn dựng sẵn bảng 7×4 mà 90% ô
    // không ai dùng.
    rieng: (muc, ma) => laAdmin || user?.permissions?.[muc]?.[ma] === true,
  };
}
